import PropTypes from "prop-types";
import React from "react";
import { Converter } from "react-showdown";
import Counters from "./Counters";

// noinspection JSUnusedGlobalSymbols
const converter = new Converter({
    strikethrough: true,
    simpleLineBreaks: true,
    components: {
        Counters,
    },
});

/**
 * @return {object}
 */
const Markdown = ({
                      text,
                  }) => {
    if (!text) {
        return null;
    }
    return <div className="markdown">
        {converter.convert(text)}
    </div>;
};

Markdown.propTypes = {
    text: PropTypes.string.isRequired,
};

export default Markdown;



// WEBPACK FOOTER //
// ./src/util/Markdown.js